export const FAQ = [
  {
    section: 'LLCIncorporation',
    items: [
      {
        title: <div className="faqTitle">What is an LLC?</div>,
        body: <div className="faqDetails">bla</div>,
      },
      {
        title: <div className="faqTitle">What are the benefits of an LLC?</div>,
        body: (
          <div className="faqDetails">
            An LLC provides its members with limited liability, meaning that
            their personal assets are protected in case the company is faced
            with legal action or debt. It also allows for flexible management
            and tax structures, and is relatively simple to establish and
            manage.
          </div>
        ),
      },
      {
        title: <div className="faqTitle">Is an LLC right for me?</div>,
        body: <div className="faqDetails">bla</div>,
      },
      {
        title: (
          <div className="faqTitle">
            How much does it cost to incorporate with Incorpified?
          </div>
        ),
        body: <div className="faqDetails">bla</div>,
      },
      {
        title: <div className="faqTitle">Do I need registered agent?</div>,
        body: <div className="faqDetails">bla</div>,
      },
      {
        title: (
          <div className="faqTitle">
            Whats the difference between an LLC and a Corporation?
          </div>
        ),
        body: <div className="faqDetails">bla</div>,
      },
    ],
  },
];

export const LLCIncorporation_FAQ = [
  {
    title: <div className="faqTitle">What is an LLC?</div>,
    body: (
      <div className="faqDetails">
        An LLC, or Limited Liability Company, is a business structure that
        combines elements of both a corporation and a partnership. It provides
        personal liability protection for its owners, called members, and allows
        for flexible management and taxation. They are relatively easy to set up
        and maintain and is a popular choice for small businesses.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">What are the benefits of an LLC?</div>,
    body: (
      <div className="faqDetails">
        An LLC provides its members with limited liability, meaning that their
        personal assets are protected in case the company is faced with legal
        action or debt. It also allows for flexible management and tax
        structures, and is relatively simple to establish and manage.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">Is an LLC right for me?</div>,
    body: (
      <div className="faqDetails">
        An LLC is the perfect choice for anyone looking to start a small
        business while keeping their personal assets safe and secure. With the
        added flexibility of management and taxation options, an LLC is the
        ultimate business structure for those who value both protection and
        freedom.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How much does it cost to incorporate with Incorpified?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Incorpified makes incorporating an LLC easy and affordable, with prices
        ranging from $199 to $399. Our comprehensive package includes everything
        you need to get your LLC up and running, including expert assistance
        with paperwork and filing fees. State fees are not included in this
        pricing and will differ depending on the state you are incorporating in.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">Do I need registered agent?</div>,
    body: (
      <div className="faqDetails">
        A registered agent is a must-have for any LLC, as it ensures that
        important legal documents and correspondence are received and handled
        promptly and efficiently. Don&#39;t take the risk of missing out on
        critical information that could affect the future of your business. With
        a registered agent, you can rest easy knowing that your business is in
        good hands and that all official communications will be handled
        professionally and efficiently.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Whats the difference between an LLC and a Corporation?
      </div>
    ),
    body: (
      <div className="faqDetails">
        LLCs (Limited Liability Companies) and Corporations are two different
        types of business structures. LLCs provide personal liability protection
        for its members, have flexible management and taxation options, and are
        relatively easy to set up and maintain. Corporations, on the other hand,
        have a more complex organizational structure, shares can be traded
        publicly and has a board of directors, they are subject to more
        regulation and are taxed differently. The choice between LLC or
        Corporation depends on the specific goals and needs of the business.
      </div>
    ),
  },
];
export const Payroll_FAQ = [
  {
    title: (
      <div className="faqTitle">What is payroll and why is it important?</div>
    ),
    body: (
      <div className="faqDetails">
        Payroll refers to the process of paying employees for the work they have
        done, including calculating salaries, taxes, benefits, and other
        deductions. It&#39;s important because it ensures that employees are
        paid accurately and on time, while also complying with relevant laws and
        regulations.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">What is a payroll service?</div>,
    body: (
      <div className="faqDetails">
        A payroll service is a third-party service that manages payroll
        processes for a company, including calculating salaries, taxes,
        benefits, and other deductions. It provides a convenient and efficient
        solution for companies to handle their payroll responsibilities.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">How does a payroll service work?</div>,
    body: (
      <div className="faqDetails">
        A payroll service receives employee information from a company,
        calculates salaries and taxes, and generates paychecks or direct
        deposits. The service also handles the filing of required tax forms and
        compliance with relevant laws and regulations.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What are the benefits of using a payroll service?
      </div>
    ),
    body: (
      <div className="faqDetails">
        The benefits of using a payroll service include saving time and reducing
        errors, ensuring compliance with tax laws and regulations, and freeing
        up resources for companies to focus on core business activities.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Can a payroll service help with taxes and compliance?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Yes, a payroll service can help with taxes and compliance by accurately
        calculating and withholding the correct amounts for taxes, filing
        required tax forms, and ensuring compliance with relevant laws and
        regulations.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How does a payroll service handle direct deposit and pay stubs?
      </div>
    ),
    body: (
      <div className="faqDetails">
        A payroll service can handle direct deposit by depositing employee
        salaries directly into their bank accounts. Pay stubs can be generated
        and provided to employees either electronically or in physical form.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How can a payroll service help my business save time and money?
      </div>
    ),
    body: (
      <div className="faqDetails">
        A payroll service can help save time by automating payroll processes and
        reducing the need for manual calculations and data entry. It can also
        help save money by reducing errors and ensuring compliance with tax laws
        and regulations, which can help avoid costly fines and penalties.
      </div>
    ),
  },
];
export const Virtual_Address_FAQ = [
  {
    title: (
      <div className="faqTitle">
        Can I use a virtual address as my official business address?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Yes, you can use a virtual address as your official business address for
        registering your company, receiving mail, and conducting business
        operations.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How secure is my mail and packages when using a virtual address?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Security is our top priority, Mail and packages are stored in a secure
        facility.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Will my personal information be shared with others when using a virtual
        address?
      </div>
    ),
    body: (
      <div className="faqDetails">
        No, reputable virtual address service providers take privacy and
        security seriously, and will not share your personal information with
        others without your consent.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How does a virtual address impact my company&#39;s image and branding?
      </div>
    ),
    body: (
      <div className="faqDetails">
        A virtual address can have a positive impact on your company&#39;s image
        and branding, as it gives the impression of a professional and
        established business with a prestigious address.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How can I be sure that my mail and packages are kept confidential when
        using a virtual address?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Virtual address service providers have strict policies and procedures in
        place to ensure that your mail and packages are kept confidential and
        secure at all times.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Can I customize my virtual address location and suite/box number?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Yes, You will be able to select the State and City and in most cases a
        suite/box number as well.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How is mail and package forwarding handled?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Through the online dashboard you’ll be able to view mail and packages,
        you’ll also be able to choose to delete them, or forward them to your
        home if they are important.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Will the virtual address service provider have access to my sensitive
        business information and correspondence?
      </div>
    ),
    body: (
      <div className="faqDetails">
        No, the virtual address service provider does not have access to the
        contents of your mail and packages unless instructed otherwise by you.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How much does a virtual business address cost?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Our service starts at just $24.99, a small price to pay for your
        privacy.
      </div>
    ),
  },
];
export const Merchant_Processing_FAQ = [
  {
    title: (
      <div className="faqTitle">
        Why is merchant processing important for my business?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Merchant processing is important because it enables businesses to
        securely process payments from customers, manage their finances, and
        improve the overall customer experience.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How can I get a merchant account for my business?
      </div>
    ),
    body: (
      <div className="faqDetails">
        To get a merchant account for your business, you will need to apply
        through a merchant services provider. They will typically require
        information about your business and its financial history, as well as a
        signed agreement.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What factors should I consider when choosing a merchant processing
        solution?
      </div>
    ),
    body: (
      <div className="faqDetails">
        When choosing a merchant processing solution, you should consider
        factors such as fees, security measures, customer support, convenience,
        and reporting capabilities.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How much will it cost my business to use merchant processing?
      </div>
    ),
    body: (
      <div className="faqDetails">
        The cost of using merchant processing depends on the merchant processing
        solution you choose. You will typically pay a fee for each transaction
        processed, as well as a monthly fee for using the service.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How can I ensure the security of my customers&#39; payment information?
      </div>
    ),
    body: (
      <div className="faqDetails">
        To ensure the security of your customers&#39; payment information, you
        should choose a merchant processing solution that uses the latest
        security measures, such as encryption and secure socket layer (SSL)
        technology.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What types of payments can I process through merchant processing?
      </div>
    ),
    body: (
      <div className="faqDetails">
        You can process a wide range of payments through merchant processing,
        including credit and debit card transactions, as well as online and
        mobile payments.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How can I track and manage my transactions through merchant processing?
      </div>
    ),
    body: (
      <div className="faqDetails">
        You can track and manage your transactions through merchant processing
        by using the reporting and tracking capabilities provided by the
        merchant processing solution you choose.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Can I expand my business globally with merchant processing?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Yes, some merchant processing solutions allow you to accept payments
        from customers in different countries and currencies, enabling you to
        expand your business globally.
      </div>
    ),
  },
];
export const Bookkeeping_FAQ = [
  {
    title: (
      <div className="faqTitle">
        What is the difference between bookkeeping and accounting?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Bookkeeping focuses on recording and classifying financial transactions,
        while accounting focuses on analyzing and interpreting financial
        information to make informed business decisions. Accounting also
        includes preparing financial statements, creating budgets, and offering
        financial advice.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How do bookkeeping services differ from self-bookkeeping?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Bookkeeping services are provided by trained professionals with
        expertise in maintaining financial records and tax compliance.
        Self-bookkeeping involves managing financial records and bookkeeping
        tasks in-house, without the support of a trained professional.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What is the process for setting up a bookkeeping system for a small
        business?
      </div>
    ),
    body: (
      <div className="faqDetails">
        The process of setting up a bookkeeping system includes choosing a
        bookkeeping method, selecting appropriate software, setting up chart of
        accounts, recording transactions, reconciling accounts, and producing
        financial reports.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What are the main responsibilities of a bookkeeper?
      </div>
    ),
    body: (
      <div className="faqDetails">
        A bookkeeper is responsible for recording financial transactions,
        reconciling bank statements, preparing and maintaining financial
        records, producing financial reports, and assisting with budget
        preparation and tax planning.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How does bookkeeping impact tax planning and preparation?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Accurate bookkeeping records are essential for tax planning and
        preparation. It provides financial information needed to calculate tax
        liabilities and helps to ensure compliance with tax laws and
        regulations.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What types of software and tools are commonly used for bookkeeping?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Some popular bookkeeping software and tools include QuickBooks, Xero,
        and MYOB. These software provide automated bookkeeping, invoicing, and
        financial reporting functions, as well as the ability to integrate with
        other financial systems.
      </div>
    ),
  },
];
export const Trademarking_FAQ = [
  {
    title: (
      <div className="faqTitle">What types of things can be trademarked?</div>
    ),
    body: (
      <div className="faqDetails">
        Words, phrases, logos, symbols, colors, sounds, and even smells can be
        trademarked if they are used in connection with goods or services.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How much does it cost to register a trademark?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Trademark Genius will collect and pay the government Base application
        (Sections 1 and 44), per class filing fee of $350. Our pricing includes
        a base cost of $450 per class, which covers the application filing fee
        and ensures that we can process your application thoroughly, even in
        cases where additional information is required.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        How long does the trademark registration process take?
      </div>
    ),
    body: (
      <div className="faqDetails">
        The trademark registration process typically takes around 12 months from
        the time of filing to the grant of registration.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">Can I trademark a common phrase or word?</div>
    ),
    body: (
      <div className="faqDetails">
        Common phrases or words cannot be trademarked on their own. They must be
        used in a unique and distinctive way in connection with goods or
        services to be eligible for trademark protection.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What happens if someone else is using my trademark?
      </div>
    ),
    body: (
      <div className="faqDetails">
        If someone else is using your trademark, you can file a trademark
        infringement lawsuit against them. You may also send a cease and desist
        letter asking them to stop using the mark.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">Where can I get a Cease & Desist letter?</div>
    ),
    body: (
      <div className="faqDetails">
        Our package will supply a Cease and Desist letter that you can use.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What happens after my trademark is registered?
      </div>
    ),
    body: (
      <div className="faqDetails">
        After your trademark is registered, you must use it in commerce and
        renew it every 10 years to maintain its registration. You should also
        monitor for any infringement of your trademark and take action as
        necessary.
      </div>
    ),
  },
];
export const Registered_Agent_FAQ = [
  {
    title: <div className="faqTitle">Do I need a registered agent?</div>,
    body: (
      <div className="faqDetails">
        Yes, a registered agent is typically required for most types of business
        entities, including corporations and LLCs, by state laws.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">Should I be my own Registered Agent?</div>,
    body: (
      <div className="faqDetails">
        Yes, you are able to serve as your own registered agent, however there
        are many benefits to using a registered agent service.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        What are the responsibilities of a registered agent service?
      </div>
    ),
    body: (
      <div className="faqDetails">
        The responsibilities of a registered agent service include receiving
        legal documents and official correspondence on behalf of a business
        entity, forwarding them to the business in a timely manner, and, in some
        states, filing annual reports and other documents on behalf of the
        business. They also ensure that the business is in compliance with state
        laws and regulations by handling the annual compliance requirements.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Can I change my registered agent service after my business is already
        established?
      </div>
    ),
    body: (
      <div className="faqDetails">
        It is possible to change your registered agent service after your
        business is established, however, you will need to inform the state
        government and file the necessary paperwork to update your business
        records.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Will a registered agent service help me stay in compliance with state
        laws and regulations?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Yes, a registered agent service can help ensure that your business stays
        in compliance with state laws and regulations by receiving and
        forwarding legal documents and handling annual compliance requirements.
        This can help your business avoid penalties and fines.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Are there any additional costs associated with using a registered agent
        service?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Using a registered agent service typically incurs an annual or monthly
        fee, cost may vary between $150-$250/year, depending on the services
        offered and the provider.
      </div>
    ),
  },
];

export const Ein_Tax_Id_FAQ = [
  {
    title: <div className="faqTitle">Who needs an EIN?</div>,
    body: (
      <div className="faqDetails">
        Any entity that operates as a business, hires employees, or pays taxes
        to the government typically needs an EIN. This includes corporations,
        partnerships, LLCs, sole proprietors, trusts, and estates.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        Do I still need an EIN if I dont plan on hiring employees?
      </div>
    ),
    body: (
      <div className="faqDetails">
        Even if you don&#39;t plan on hiring employees, you may still need an
        EIN if you operate as a business, have a partnership, or file certain
        tax returns
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">
        If I am a single member LLC, do I need an EIN?
      </div>
    ),
    body: (
      <div className="faqDetails">
        As a single member LLC, you are not required to have an EIN unless you
        have employees or elect to be taxed as a corporation instead of a sole
        proprietorship. However, obtaining an EIN is often recommended for tax
        and banking purposes, and some states may require it for state tax or
        licensing purposes.
      </div>
    ),
  },
  {
    title: <div className="faqTitle">What entities require an EIN?</div>,
    body: (
      <div className="faqDetails">
        Most entities that operate as a business or have tax obligations in the
        US require an EIN. This includes corporations, partnerships, LLCs, sole
        proprietors, estates, trusts, non-profit organizations, and government
        agencies
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">What is Error 101 and how do I fix it?</div>
    ),
    body: (
      <div className="faqDetails">
        Error 101 is a common error code that occurs when attempting to file an
        application for an EIN (Employer Identification Number) online with the
        Internal Revenue Service (IRS). This error typically occurs when there
        is an issue with the information provided on the application form, such
        as incorrect or incomplete data, or if the applicant has already
        received an EIN for the same entity. The best way to resolve this error
        is to review the information provided and resubmit the application with
        any necessary corrections.
      </div>
    ),
  },
  {
    title: (
      <div className="faqTitle">Can I use an EIN for multiple businesses?</div>
    ),
    body: (
      <div className="faqDetails">
        No, you cannot use the same EIN for multiple businesses. Each business
        must have its own unique EIN, as it is used to identify the specific
        entity for tax and other purposes.
      </div>
    ),
  },
];
